import React, { Component } from "react"
import { yearsOfStudy, academicEducation, secularEducation, bagroot} from '../../variables/ComboValues'
import { updateElement } from "../Tree/Utils.js"
import { box_element } from './ParentEmployment'


export const  ParentEducation_microLegend = {
    "year_of_study": "שנות לימוד",
    "bagroot": "בגרות",
    "professional": "השכלה מקצועית",
    "academic_education": "השכלה אקדמית",
    "secular_education": "השכלה דתית", 
    "profession": "מקצוע",
    "comment": "הערות"
}
const emptyProduct = [{
    "id": 1,
    "year_of_study": "",
    "bagroot": "",
    "professional": "",
    "academic_education": "",
    "secular_education": "",
    "profession": "",
    "comment": ""
  }]
  
export class ParentEducation extends Component {

    constructor(props) {
      super(props)
      this.state = { products: typeof this.props.data === "undefined" ? emptyProduct :  this.props.data}
      this.onSaveTable = this.onSaveTable.bind(this)
      this.handleProductTable = this.handleProductTable.bind(this)
    }
    
    handleProductTable(evt) {
        evt.preventDefault()
        var newp= updateElement(evt, this.state.products)
        this.setState({products:newp})
    }

    // update data base
    onSaveTable(evt) {
      evt.preventDefault()
      const { save2DB, subTableId, memberPostId } = this.props
      // console.log("Family General save table: products", this.state.products)
      save2DB(memberPostId, this.state.products, subTableId, "group" )
    }
    render() {
      const {tableTitle} = this.props
      // const { data } = this.props
      // console.log("Family general data", data)
      // console.log("OLD meeting data", this.state.products)
      
      return (
          <ProductTable 
            onProductTableUpdate={this.handleProductTable}
            onSaveTable={this.onSaveTable} 
            tableTitle = {tableTitle} // "סיכומי מפגשים"
            products={this.state.products} 
          />
      )
    }
  }
   
  class ProductTable extends Component {
    constructor(props){
        super(props)
        this.state={
            filterText : ""
        }
    }
    
    handleUserInput(filterText) {
        this.setState({filterText: filterText});
    }
    render() {
      const { onProductTableUpdate, products, tableTitle, onSaveTable } = this.props     
      var product = products
     
      const cellData=[{
            type: "select",
            options: yearsOfStudy,
            name: "year_of_study",
            value: product.year_of_study,
            id: product.id,
            style: {width: "60px"},
            edit: true
          },{
            type: "select",
            options: bagroot, // ["בגרות מלאה","בגרות חלקית","אין"],
            name: "bagroot",
            value: product.bagroot,
            id: product.id,
            style: {width: "80px"},
            edit: true
          },{
            type: "text",
            name: "professional",
            value: product.professional,
            id: product.id,
            style: {width: "150px"},
            edit: true
          },{
            type: "select",
            options: academicEducation, //["לימודים לתואר ראשון","תואר ראשון (בוגר)","לימודים לתואר שני"," (מוסמך)תואר שני",
            //"לימודים לתואר שלישי","בעל תואר דוקטור","מהנדס","רופא","אחר"],
            name: "academic_education",
            value: product.academic_education,
            id: product.id,
            style: {width: "150px"},
            edit: true
          },{
            type: "select",
            options: secularEducation, // ["סמיכה לרבנות שכונה – ''יורה יורה''","סמיכה לרבנות עיר","משגיח כשרות","תעודת השכלה תורנית גבוהה",
            //"מוהל מוסמך","מוהל מומחה","סופר סת''ם","אחר"],
            name: "secular_education",
            value: product.secular_education,
            id: product.id,
            style: {width: "180px"},
            edit: true
          },{
            type: "text",
            name: "profession",
            value: product.profession,
            id: product.id,
            style: {width: "220px"},
            edit: true
          },{
            type: "textarea",
            name: "comment",
            value: product.comment,
            id: product.id,
            style: {width: "190px"},
            edit: true
          }] 
          
      return (box_element(tableTitle, onSaveTable, onProductTableUpdate, product, cellData, ParentEducation_microLegend ))
    }
  }
